var map = {
	"./3562a8f7476b4213a728cd03e0c5cf6d.jpg": 228,
	"./36118a6d118944889fb6fa39816c2547.jpg": 17254,
	"./40c2459d0a1544a98556b34f94701bb7.jpg": 88200,
	"./47091c1b75d4433db624d445c971cf9a.jpg": 82861,
	"./4ac7821e4b0640f39049313d83b24504.jpg": 42614,
	"./4b1b5fb119b64624b1a44be449805df8.jpg": 83339,
	"./5129eedce55f422c92ac6bab97cb82de.jpg": 72557,
	"./753f30eb61ff4d649c1c00855e3ca68d.jpg": 4535,
	"./7f6a45de54f04085b44882d2bfdbc61b.jpg": 35035,
	"./8dfe4fdba19949fe861816762c9fb9b9.jpg": 86607,
	"./9b5615e2afe94f7fa8467f442933a773.jpg": 29101,
	"./9ed8d94e40d24d0d9932ed68359ec211.jpg": 27646,
	"./Acknowledgements.jpg": 34490,
	"./Buffleheads.jpg": 46910,
	"./CoverArtKristiBridgeman.jpg": 12194,
	"./Ecosystem.jpg": 6189,
	"./Fern.jpg": 3478,
	"./IslandFarmFreshLogo2.jpg": 45799,
	"./LocalsNatureHood/AmericanWigeon.jpg": 33146,
	"./LocalsNatureHood/Arbutus.jpg": 95585,
	"./LocalsNatureHood/BaldEagle.jpg": 81774,
	"./LocalsNatureHood/BananaSlug.jpg": 11649,
	"./LocalsNatureHood/BeltedKingfisher.jpg": 73413,
	"./LocalsNatureHood/Bumblebee.jpg": 12678,
	"./LocalsNatureHood/CommonCamas.jpg": 83071,
	"./LocalsNatureHood/DouglasFir.jpg": 43079,
	"./LocalsNatureHood/Eelgrass.jpg": 42459,
	"./LocalsNatureHood/FawnLily.jpg": 75995,
	"./LocalsNatureHood/GarryOak.jpg": 11091,
	"./LocalsNatureHood/GreatBlueHeron.jpg": 98364,
	"./LocalsNatureHood/HarbourSeal.jpg": 50025,
	"./LocalsNatureHood/HermitCrab.jpg": 62220,
	"./LocalsNatureHood/HoodedMerganser.jpg": 84532,
	"./LocalsNatureHood/JunePlum.jpg": 45825,
	"./LocalsNatureHood/LicoriceFern.jpg": 39620,
	"./LocalsNatureHood/LorquinsAdmiral.jpg": 49092,
	"./LocalsNatureHood/Orca.jpg": 32600,
	"./LocalsNatureHood/PacificChorusFrog.jpg": 5770,
	"./LocalsNatureHood/PacificWren.jpg": 62184,
	"./LocalsNatureHood/RedSquirrel.jpg": 3235,
	"./LocalsNatureHood/RiverOtter.jpg": 57563,
	"./LocalsNatureHood/Salmon.jpg": 91749,
	"./LocalsNatureHood/Salmonberry.jpg": 51253,
	"./LocalsNatureHood/WesternPurpleMartin.jpg": 84918,
	"./LocalsNatureHood/WesternTerrestrialGarterSnake.jpg": 34641,
	"./LocalsNatureHood/WoodDuck.jpg": 75463,
	"./Naturehood-Plaque.jpg": 92961,
	"./Restoration.jpg": 1133,
	"./Riparian.jpg": 90853,
	"./Riparian2.jpg": 86523,
	"./Waterways.jpg": 40140,
	"./ab1da2da94e547f5b11e2d85ae2582c8.jpg": 5646,
	"./bc3a56b806144f189441a9004d89df49.jpg": 50641,
	"./c96da12a317e459292b647eb56236b33.jpg": 69039,
	"./d09c948ad4c445b398f8b7f94e9d5e0c.jpg": 1474,
	"./d3d137bcdd064eed929dba983340ab99.jpg": 74755,
	"./de6b3944ab554d1899f0ef0915e796ff.jpg": 91719,
	"./e37c5d33da1343e383c66a215f2e2b5b.jpg": 5191,
	"./e9a1ca04074d44eba6fd6f2f3972443c.jpg": 98457,
	"./ed475345091f4dc58a9bf03a0f942b63.jpg": 76854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29218;